<template>
  <v-autocomplete
    id="asset-selection"
    v-model="selectedAssetId"
    :loading="status === 'pending'"
    :items="assetOptions"
    item-title="title"
    item-value="_id"
    clearable
    :placeholder="$t('tickets.placeholder.asset')"
    :rules="[(val) => !!val || $t('validation.required')]"
  >
    <template #selection="{ item }">
      <div class="d-flex ga-4 align-center">
        <category-avatar disable-tooltip :category="item.category" />

        <div>
          <div class="font-weight-medium mb-n1">
            {{ item.key }}
          </div>

          <div>
            {{ item.description }}
          </div>
        </div>
      </div>
    </template>

    <template #item="{ item, props: itemProps }">
      <v-list-item v-bind="itemProps" :title="undefined">
        <template #prepend>
          <category-avatar disable-tooltip :category="item.category" />
        </template>

        <div class="font-weight-medium mb-n1">
          {{ item.key }}
        </div>

        <div>
          {{ item.description }}
        </div>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script setup lang="ts">
const selectedAssetId = defineModel<string>()
const asset = defineModel<AssetSubset | undefined>("asset")

const props = defineProps<{ organizationId?: string }>()
const { organizationId } = toRefs(props)

const assetStore = useAssetStore()
const ticketStore = useTicketStore()

const { data: assets, status } = useLazyAsyncData(
  `assets-lookup:${organizationId.value}`,
  async () => {
    if (!organizationId.value) {
      return [] as Array<LookupAsset>
    }

    const query = organizationId.value
      ? {
          query: {
            organization: organizationId.value,
          },
        }
      : undefined

    return await assetStore.getManyLookup(query)
  },
  {
    default: () => [] as Array<LookupAsset>,
    watch: [organizationId],
  },
)

const assetOptions = computed(() => {
  return assets.value.map((asset) => ({
    _id: asset._id,
    key: asset.key,
    description: asset.description,
    category: asset.category,
    title: `${asset.key} | ${asset.description}`,
  }))
})

watch(selectedAssetId, async () => {
  // asset.value = assets.value.find((asset) => asset._id === newValue)
  if (!selectedAssetId.value) {
    asset.value = undefined
    return
  }

  asset.value = await ticketStore.getTicketAssetById(selectedAssetId.value)
})
</script>
